// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f3786e78","977":"01eaccb3"}[chunkId] + ".chunk.js";
};